import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  signal,
  ViewChild,
} from '@angular/core';

import { NimmstaCommonsModuleConfiguration } from '@nimmsta/ng-commons-lib/config';
import { Pageable, WorkflowHistoryEntry } from '@nimmsta/ng-commons-lib/models';
import { WorkflowService } from '@nimmsta/ng-commons-lib/services/workflow';

import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'workflow-history-dropdown',
  standalone: true,
  templateUrl: './workflow-history-entry-selection.component.html',
  styleUrls: ['./workflow-history-entry-selection.component.scss'],
  imports: [DatePipe, Select, FormsModule, TranslatePipe,
  ],
})
export class HistoryDropdownComponent {
  @ViewChild('historySelect') historySelect!: Select;
  private workflowService = inject(WorkflowService);

  private configuration = inject(NimmstaCommonsModuleConfiguration);


  @Input() workflowId!: string;

  @Output() selected = new EventEmitter<WorkflowHistoryEntry>();

  definitionHistory = signal<WorkflowHistoryEntry[]>([]);

  historyPagesLoaded = 0;

  lastPageLoaded = signal<boolean>(false);

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  loading = false;

  currentQuery?: string = undefined

  error?: HttpErrorResponse;

  open = signal(false);
  search = signal('');

  onSearchInputChange(searchInput: string) {
    this.historyPagesLoaded = 0;
    this.lastPageLoaded.set(false);
    const term = searchInput.trim().toLowerCase();
    this.currentQuery = term;
    this.loadDefinitionHistory(0, true);
  }

  clearSelection() {
    this.historySelect.clear();
  }

  openList() {
      this.loadDefinitionHistory(0, true);
  }
  close() {
    this.open.set(false);
  }

  select(item: WorkflowHistoryEntry) {
    if (item) {
      this.selected.emit(item);
    }
    this.close();
  }

  loadNextPage() {
    this.loadDefinitionHistory(this.historyPagesLoaded);
  }

  @HostListener('document:click', ['$event'])
  onDocClick(ev: MouseEvent) {
    if (!this.host.nativeElement.contains(ev.target as Node)) this.close();
  }

  toDate(input: WorkflowHistoryEntry): string | undefined {
    return input.lastUpdatedAt ? input.lastUpdatedAt.toString() : undefined;
  }

  private loadDefinitionHistory(
    page: number,
    resetList = false,
  ) {
    const pageSize = this.configuration.defaultPageSize || 10;
    if (page >= this.historyPagesLoaded && !this.lastPageLoaded()) {
      const apiRequest = this.currentQuery
        ? this.workflowService.getDefinitionHistorySearch(
            this.workflowId,
            page,
            pageSize,
            this.currentQuery,
          )
        : this.workflowService.getDefinitionHistory(
            this.workflowId,
            page,
            pageSize,
          );
      this.loading = true;
      apiRequest.subscribe({
        next: (pageable: Pageable<WorkflowHistoryEntry>) => {
          if (resetList) {
            this.definitionHistory.set(pageable.content);
          } else {
            this.definitionHistory.set(
              this.definitionHistory().concat(pageable.content),
            );
          }
          this.historyPagesLoaded += 1;
          this.lastPageLoaded.set(pageable.last);
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.error = error;
          this.loading = false;
        },
      });
    }
  }
}
